var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgVector = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 8,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#494A4E",
  d: "M1.41.08 6 4.67 10.59.08 12 1.5l-6 6-6-6L1.41.08Z"
})));
export { SvgVector as ReactComponent };
export default __webpack_public_path__ + "b51eb511e2f7d924eb614ed47727bbd3.svg";